import { useQuery } from '@apollo/client/react';
import { useTranslation } from 'react-i18next';
import { STAFF_EMPLOYEE_PEERS } from '@scio3/graphql-client';
import type { EmployeePeer } from '@scio3/shared-types';
import { DevicesTable } from '../components/DevicesTable';
import { PeersTableBySubnet } from '../components/PeersTableBySubnet';

export function EmployeePeersPage() {
  const { t } = useTranslation();
  const { data, loading, error } = useQuery<{ staffEmployeePeers: EmployeePeer[] }>(
    STAFF_EMPLOYEE_PEERS,
    {
      fetchPolicy: 'cache-and-network',
    },
  );
  const peers = data?.staffEmployeePeers ?? [];

  return (
    <div className="flex flex-col gap-8 p-6" data-testid="employee-peers-page">
      <div>
        <h1 className="text-2xl font-bold text-foreground">{t('Network / Peers')}</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t('Everyone and everything with WireGuard credentials. Read-only.')}
        </p>
      </div>

      {error ? (
        <div className="rounded-md border border-destructive/30 bg-destructive/5 p-4 text-sm text-destructive">
          {error.message}
        </div>
      ) : loading && !peers.length ? (
        <div className="text-sm text-muted-foreground">{t('Loading peers…')}</div>
      ) : (
        <PeersTableBySubnet peers={peers} />
      )}

      <DevicesTable />
    </div>
  );
}
